import {
  IBranchContactsSliderTheme,
  ISliderButtonTheme
} from 'app/interfaces/ui';

export const sliderButtonThemes: Record<
  'graphite' | 'sand' | 'gray',
  ISliderButtonTheme
> = {
  graphite: {
    bgColor: 'bg-graphite-dark',
    bgColorHover: 'hover:bg-graphite-light',
    borderColor: 'border-transparent',
    borderColorHover: 'hover:border-transparent',
    iconColor: 'stroke-brown'
  },
  sand: {
    bgColor: 'bg-sand-dark',
    bgColorHover: 'hover:bg-sand-dark',
    borderColor: 'border-transparent',
    borderColorHover: 'hover:border-transparent',
    iconColor: 'stroke-brown',
    iconColorHover: 'hover:stroke-brown'
  },
  gray: {
    bgColor: 'bg-gray',
    bgColorHover: 'hover:bg-gray-dark',
    borderColor: 'border-brown',
    borderColorHover: 'hover:border-brown',
    iconColor: 'stroke-brown',
    iconColorHover: 'hover:stroke-brown'
  }
};

export const branchContactsSliderThemes: Record<
  'dark' | 'light',
  IBranchContactsSliderTheme
> = {
  dark: {
    itemTheme: {
      bgColor: 'bg-graphite-dark',
      bgColorHover: 'hover:bg-graphite-dark'
    },
    buttonTheme: sliderButtonThemes.graphite
  },
  light: {
    itemTheme: {
      bgColor: 'bg-gray',
      bgColorHover: 'hover:bg-gray'
    },
    buttonTheme: sliderButtonThemes.sand
  }
};
